import { render, staticRenderFns } from "./download.html.vue?vue&type=template&id=08dd1721"
import script from "./download.html.vue?vue&type=script&lang=js"
export * from "./download.html.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/download/download.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports